// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"302":"431ddeee","571":"37bb3a35","818":"b65457fd"}[chunkId] + ".chunk.css";
};